import { render, staticRenderFns } from "./TextSlider.vue?vue&type=template&id=abd1485c&scoped=true"
import script from "./TextSlider.vue?vue&type=script&lang=js"
export * from "./TextSlider.vue?vue&type=script&lang=js"
import style0 from "./TextSlider.vue?vue&type=style&index=0&id=abd1485c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd1485c",
  null
  
)

export default component.exports